import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { Box } from "@mui/material";
import IconButton from '@mui/material/IconButton';
import { observer } from "mobx-react-lite";
import React, { useContext, useEffect, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import styled from "styled-components";
import { signOut } from "../../services/LoginService";
import { getProfile } from "../../services/PersonalService";
import { RootStoreContext } from "../../store";
import classes from "./MainNevigation.module.css";

const DropDownContainer = styled("div")`
  width: 5em;
  margin: 0 auto;
  // float: left;
`;

const DropDownHeader = styled("div")`
  // margin-bottom: 0.8em;
  font-size: 18px;
  // color: #3faffa;
  display: flex;
  width: 0;
  height: 0;
  background: white;
  border-left: 8px solid transparent;
  border-right: 8px solid transparent;
  border-top: 12px solid #575757;
  border-radius: 5px;
  cursor: pointer;
`;

const DropDownListContainer = styled("div")`
  display: flex;
  margin: 5rem 0 0 90%;
  float: right;
  position: fixed;
  z-index: 999;
`;

const DropDownList = styled("ul")`
  padding: 0.5em;
  margin: 0;
  color: #696969;
  font-size: 18px;
  background: #ffffff;
  border: 1px solid #f8f8f8;
  box-sizing: border-box;
  box-shadow: 0px 10px 30px rgba(0, 0, 0, 0.1);
  border-radius: 5px;
  &:first-child {
    padding-top: 0.5em;
  }
`;

const ListItem = styled("button")`
  list-style: none;
  // margin-bottom: 0.5em;
  background-color: white;
  border: none;
  color: #696969;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 16px;
  margin: 2px 2px;
  cursor: pointer;
  width: 100%;
  :hover {
    background-color: #f7f7f7;
  }
`;

function MainNevigation() {
  const { LoginStore, PersonalStore } = useContext(RootStoreContext);
  const { login } = LoginStore;
  const { profile_picture, username, updateData } = PersonalStore;
  const history = useHistory();

  useEffect(() => {
    getProfile()
      .then((value) => {
        console.log(value);
        updateData("username", value.username);
        updateData("profile_picture", value.profile_picture);
      })
      .catch(console.log);
  }, []);
  const [stickyClass, setStickyClass] = useState("");

  useEffect(() => {
    window.addEventListener("scroll", stickNavbar);
    return () => window.removeEventListener("scroll", stickNavbar);
  }, []);

  const stickNavbar = () => {
    if (window !== undefined) {
      let windowHeight = window.scrollY;
      // window height changed for the demo
      windowHeight > 10
        ? setStickyClass(classes.sticky)
        : setStickyClass(classes.navbar);
    }
  };
  const [isOpen, setIsOpen] = useState(false);
  const toggling = () => setIsOpen(!isOpen);

  useEffect(() => {
    setIsOpen(false);
  }, [login]);

  const handleBack = () => {
    if(history.location.pathname === "/Profile") history.push("/")
    else history.goBack()
  }

  return (
    <>
      <div>
        <header className={`${classes.header} ${classes.sticky}`}>
          <Link className={classes.logo} to="/">
            <h3>STARTUPSPEEDUP </h3>
            &nbsp;&nbsp;
            <h6 className={classes.beta}>beta</h6>
          </Link>
          {login && (
            <Box className={classes.maindiv}>
              <div className={classes.title}>您好，{username}</div>
              <img src={profile_picture} alt="profile" className={classes.img} />
              {/* <DropDownBtn style={{ marginLeft: "5%" }} /> */}
              <DropDownContainer>
                <DropDownHeader
                  onClick={toggling}
                // className={classes.down}
                ></DropDownHeader>
              </DropDownContainer>
            </Box>
          )}
        </header>
        {login && isOpen && (
          <DropDownListContainer>
            <DropDownList>
              <Link to="/">
                <ListItem
                  onClick={() => {
                    signOut();
                  }}
                >
                  登出
                </ListItem>
              </Link>
              <a
                className={classes.mainpage_footer_word}
                href="https://forms.gle/kUckCKT2dUPU65zf7"
              >
                <ListItem>報修表單</ListItem>
              </a>
            </DropDownList>
          </DropDownListContainer>
        )}
      </div>
      <IconButton sx={{
        position: "absolute",
        top: "15%",
        left: "5%"
      }} onClick={handleBack}>
        <ArrowBackIcon />
      </IconButton>
    </>
  );
}

export default observer(MainNevigation);
